import React, { FC } from 'react';
import { IMessage } from '@sv-support-sdk/chat-shared-types/src/common/messages';
import ActionsItem from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions/ActionsItem';
import Actions from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions';

import Button from '../../ui/Controls/Button';
import Paragraph from '../../ui/Typography/Paragraph';

import { $l } from '../../../locales';
import setQaAttribute from '../../../helpers/setQaAttribute';

const QuickActions: FC<{ message: IMessage }> = ({ message }) => (
  <Actions direction="column" gap="4" align="end">
    <ActionsItem>
      <Paragraph fontWeight="500" fontSize="12" className="indent-xm-right">
        {$l('QUICK_ACTIONS')}
      </Paragraph>
    </ActionsItem>
    {message.actions?.map((el) => (
      <ActionsItem key={el.name}>
        <Button
          size="small"
          text={el.name}
          radius="20"
          variant="primary-outlined"
          onClick={el.method}
          {...setQaAttribute(el.qaId)}
        />
      </ActionsItem>
    ))}
  </Actions>
);

export default QuickActions;
